module.exports = __webpack_public_path__ + "static/media/image3.1f893662.png";